import { registerBlockType } from '@wordpress/blocks'
import { Path, Rect, SVG } from '@wordpress/components'
import { select } from '@wordpress/data'
import MetaTextField from '../Meta/MetaTextField'
import ReactPhoneInput from 'react-phone-input-2'
import MetaSelect from '../Meta/MetaSelect'
import Companies from '../Components/SelectOptions/Companies'
import AddressState from '../Components/SelectOptions/AddressState'
import { store as editorStore } from '@wordpress/editor'

registerBlockType('usna1978/classmate-contact-info', {
  title: 'Classmate: Contact Info',
  description: 'Allows the user to add pertinent contact information about the classmate.',
  // eslint-disable-next-line react/jsx-pascal-case
  icon: <SVG viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><Path d='M0,0h24v24H0V0z' fill='none' /><Path d='M20,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M20,18H4V6h16V18z' /><Rect x='6' y='10' width='2' height='2' /><Rect x='6' y='14' width='8' height='2' /><Rect x='16' y='14' width='2' height='2' /><Rect x='10' y='10' width='8' height='2' /></SVG>,
  category: 'formatting',
  attributes: {
    addressCity: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_address_city'
    },
    addressLat: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_address_lat'
    },
    addressLong: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_address_long'
    },
    addressState: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_address_state'
    },
    addressStateOther: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_address_state_other'
    },
    addressStreet: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_address_street'
    },
    addressZip: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_address_zip'
    },
    businessEmail: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_business_email'
    },
    businessPhone: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_business_phone'
    },
    cellPhone: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_cell_phone'
    },
    company: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_company'
    },
    firstName: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_first_name'
    },
    homePhone: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_home_phone'
    },
    lastName: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_last_name'
    },
    lastUpdated: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_last_updated'
    },
    loginEmail: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_login_email'
    },
    middleName: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_middle_name'
    },
    nick: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_nick'
    },
    otherEmail: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_other_email'
    },
    personalEmail: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_personal_email'
    },
    spouseName: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_spouse_name'
    },
    suffix: {
      type: 'string',
      source: 'meta',
      meta: 'usna1978_suffix'
    },
    pageId: {
      type: 'number'
    }
  },

  /**
   * The edit function describes the structure of your block in the context of
   * the editor. This represents what the editor will render when the block is
   * used.
   *
   * The "edit" property must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  edit ({ state, attributes, setAttributes }) {
    const { addressState, businessPhone, cellPhone, homePhone } = attributes

    const getCurrentPostID = () => {
      return select(editorStore).getCurrentPostId()
    }
    const getCurrentPostType = () => {
      return select(editorStore).getCurrentPostType()
    }
    const getCurrentClassmateName = () => {
      return select(editorStore).getEditedPostAttribute('title')
    }

    if (getCurrentPostType(state) === 'classmates') {
      document.getElementsByClassName('editor-post-title')[0].classList.add('wp-blocks-classmate-title')
    }

    setAttributes({
      pageId: getCurrentPostID(state)
    })

    return (
      <div className='panel panel-default'>
        <div className='panel-heading'>
          <strong>{(() => getCurrentClassmateName(state))()}</strong>
        </div>
        <div className='panel-body'>
          <table className='borderless'>
            <tbody>
              <tr><th colSpan='2'>Name & Company</th></tr>
              <tr><td>First</td><td><MetaTextField fieldName='usna1978_first_name' /></td></tr>
              <tr><td>Middle</td><td><MetaTextField fieldName='usna1978_middle_name' /></td></tr>
              <tr><td>Last</td><td><MetaTextField fieldName='usna1978_last_name' /></td></tr>
              <tr><td>Suffix</td><td><MetaTextField fieldName='usna1978_suffix' /></td></tr>
              <tr><td>Nick</td><td><MetaTextField fieldName='usna1978_nick' /></td></tr>
              <tr>
                <td>Company</td>
                <td>
                  <MetaSelect
                    fieldName='usna1978_company'
                    options={Companies}
                  />
                </td>
              </tr>
              <tr><td>Spouse Name</td><td><MetaTextField fieldName='usna1978_spouse_name' /></td></tr>
              <tr><th colSpan='2'>Address</th></tr>
              <tr><td>Street</td><td><MetaTextField fieldName='usna1978_address_street' /></td></tr>
              <tr><td>City</td><td><MetaTextField fieldName='usna1978_address_city' /></td></tr>
              <tr>
                <td>State</td>
                <td>
                  <MetaSelect
                    fieldName='usna1978_address_state'
                    options={AddressState}
                  />
                  {(() => (addressState === 'Other') ? <MetaTextField fieldName='usna1978_address_state_other' /> : '')()}
                </td>
              </tr>
              <tr><td>Zip</td><td><MetaTextField fieldName='usna1978_address_zip' /></td></tr>
              <tr><td>Lat</td><td><MetaTextField fieldName='usna1978_address_lat' /></td></tr>
              <tr><td>Long</td><td><MetaTextField fieldName='usna1978_address_long' /></td></tr>
              <tr><th colSpan='2'>Phone Numbers</th></tr>
              <tr>
                <td>Home</td>
                <td>
                  <ReactPhoneInput
                    defaultCountry='us'
                    onlyCountries={['us']}
                    placeholder='(123) 456-7890'
                    disableDropdown
                    disableCountryCode
                    inputClass='components-text-control__input'
                    value={homePhone}
                    onChange={value => setAttributes({ homePhone: value })}
                  />
                </td>
              </tr>
              <tr>
                <td>Business</td>
                <td>
                  <ReactPhoneInput
                    defaultCountry='us'
                    onlyCountries={['us']}
                    placeholder='(123) 456-7890'
                    disableDropdown
                    disableCountryCode
                    inputClass='components-text-control__input'
                    value={businessPhone}
                    onChange={value => setAttributes({ businessPhone: value })}
                  />
                </td>
              </tr>
              <tr>
                <td>Cell</td>
                <td>
                  <ReactPhoneInput
                    defaultCountry='us'
                    onlyCountries={['us']}
                    placeholder='(123) 456-7890'
                    disableDropdown
                    disableCountryCode
                    inputClass='components-text-control__input'
                    value={cellPhone}
                    onChange={value => setAttributes({ cellPhone: value })}
                  />
                </td>
              </tr>
              <tr><th colSpan='2'>Emails</th></tr>
              <tr><td>Login</td><td><MetaTextField fieldName='usna1978_login_email' /></td></tr>
              <tr><td>Business</td><td><MetaTextField fieldName='usna1978_business_email' /></td></tr>
              <tr><td>Personal</td><td><MetaTextField fieldName='usna1978_personal_email' /></td></tr>
              <tr><td>Other</td><td><MetaTextField fieldName='usna1978_other_email' /></td></tr>
              <tr><td>Last Updated</td><td><MetaTextField fieldName='usna1978_last_updated' disabled /></td></tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  },

  /**
   * The save function defines the way in which the different attributes should
   * be combined into the final markup, which is then serialized by Gutenberg
   * into post_content.
   *
   * The "save" property must be specified and must be a valid function.
   *
   * @link https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/
   */
  save () {
    return null
  }
})
